(() => {
  if (customElements.get('bolero-extra-box')) return;
  let pending = false;

  class BoleroMixedBox extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      
      
      
      this.copy = JSON.parse(this.querySelector('[data-offer-copy]').textContent);
      this.label = this.button.textContent;
      this.button.disabled = false;
      this.addEventListener('change', (event) => event.stopPropagation());
      this.button.addEventListener('click', () => this.addOffer());
    }

    route(endpoint) {
      return `${window.Shopify?.routes?.root || '/'}cart/${endpoint}.js`;
    }

    async request(endpoint, body) {
      const response = await fetch(this.route(endpoint), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || this.copy.addError);
      return result;
    }

    async readCart() {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error(this.copy.cartError);
      return response.json();
    }

    async rollback(requestId, discountCodes) {
      const cart = await this.readCart();
      const added = cart.items.find((item) => item.properties?._bolero_offer_request === requestId);
      if (added) await this.request('change', { id: added.key, quantity: 0 });
      await this.request('update', { discount: discountCodes.join(',') });
    }

    renderCart(result) {
      const drawer = this.closest('cart-drawer');
      if (drawer && result.sections?.['cart-drawer'] && result.sections?.['cart-icon-bubble']) {
        drawer.renderContents(result);
      } else {
        window.location.assign(window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`);
      }
    }

    async addOffer() {
      if (this.needsRefresh) {
        window.location.assign(window.routes?.cart_url || '/cart');
        return;
      }
      if (this.busy || this.completed || pending) return;
      this.busy = true;
      pending = true;
      this.button.disabled = true;
      this.button.textContent = this.copy.adding;
      this.status.textContent = '';
      const requestId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const expectedPrice = Number(this.dataset.offerPrice);
      const regularPrice = Number(this.dataset.regularPrice);
      const variantId = Number(this.dataset.variantId);
      let previousCodes = [];
      let attemptedAdd = false;
      let confirmed = false;
      try {
        const before = await this.readCart();
        previousCodes = (before.discount_codes || []).map((discount) => discount.code);
        if (!before.item_count || before.currency !== this.dataset.currency) throw new Error(this.copy.unavailable);
        const existingOffer = before.items.some((item) => item.properties?._bolero_offer) || before.discount_codes?.some((discount) => discount.code.toUpperCase() === this.dataset.discount && discount.applicable);
        if (existingOffer) throw new Error(this.copy.alreadyAdded);
        attemptedAdd = true;
        await this.request('add', { items: [{ id: variantId, quantity: 1, properties: { _bolero_offer: 'mixed-box-22', _bolero_offer_request: requestId } }] });
        const drawer = this.closest('cart-drawer');
        const result = await this.request('update', {
          discount: [...previousCodes.filter((code) => code.toUpperCase() !== this.dataset.discount), this.dataset.discount].join(','),
          ...(drawer ? { sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname } : {}),
        });
        const appliedCodes = result.discount_codes || [];
        const active = appliedCodes.some((discount) => discount.code.toUpperCase() === this.dataset.discount && discount.applicable);
        const priorCodesPreserved = previousCodes.every((code) =>
          appliedCodes.some((discount) => discount.code.toUpperCase() === code.toUpperCase() && discount.applicable)
        );
        const newOfferLine = result.items.find((item) => item.properties?._bolero_offer_request === requestId);
        const discountedBox = newOfferLine && newOfferLine.final_price === expectedPrice;
        const priorItemsStillDiscounted = before.items.every((oldItem) => {
          const updated = result.items.find((item) =>
            item.variant_id === oldItem.variant_id &&
            !item.properties?._bolero_offer_request &&
            item.quantity >= oldItem.quantity
          );
          return updated && updated.final_price <= oldItem.final_price;
        });
        if (!active || !discountedBox || !priorCodesPreserved || !priorItemsStillDiscounted) {
          throw new Error(this.copy.unavailable);
        }
        confirmed = true;
        this.completed = true;
        this.renderCart(result);
      } catch (error) {
        if (attemptedAdd && !confirmed) {
          try {
            await this.rollback(requestId, previousCodes);
          } catch {
            this.status.textContent = this.copy.uncertain;
            this.button.textContent = this.copy.refresh;
            this.button.disabled = false;
            this.needsRefresh = true;
            return;
          }
        }
        this.status.textContent = confirmed ? this.copy.successRefresh : error.message;
      } finally {
        this.busy = false;
        pending = false;
        if (!this.needsRefresh) {
          this.button.disabled = confirmed;
          this.button.textContent = confirmed ? this.copy.added : this.label;
        }
      }
    }
  }

  customElements.define('bolero-extra-box', BoleroMixedBox);
})();
